import React from 'react';


const Service = () => {
    return <h1 className="first_home">Hello I am Service Page </h1>;
};
export default Service;